<script setup>
    defineProps({
        image: Object
    })
</script>

<template>
    <img :src="image.src"
         :data-src="image.src"
         class="img-inner"
         :content="image.src"
         :alt="image.alt"
         role="img"
         property="v:image" />
</template>

<script>
    export default {
        name: "SVG"
    }
</script>

<style scoped lang="scss">

</style>
